import { QuestionPattern } from '../models/searchable-item.model';

export interface ExtractedIntent {
  action: string;
  target: string;
}

/**
 * Match the raw user query against natural-language question patterns
 * (e.g. "wo finde ich …", "how do I change …"). Returns the first match.
 */
export function extractIntent(
  raw: string,
  patterns: ReadonlyArray<QuestionPattern>
): ExtractedIntent | null {
  if (!raw) return null;
  for (const p of patterns) {
    for (const patternSrc of p.patterns) {
      const re = new RegExp(patternSrc, 'i');
      const m = raw.match(re);
      if (m) {
        const target = m[p.extract] ?? '';
        return { action: p.action, target };
      }
    }
  }
  return null;
}
